import "./financialAnalysis.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";

function tableRender(tableData, roofInfo) {
  const totalIncomeGenerated = Object.values(tableData)
    .reduce((sum, value) => sum + Number(value.IncomeGenerated), 0)
    .toFixed();
  const totalExportGenrated = Object.values(tableData)
    .reduce((sum, value) => sum + Number(value.exportGenerated), 0)
    .toFixed();
  const totalSavedBill = Object.values(tableData)
    .reduce((sum, value) => sum + Number(value.SavedBill), 0)
    .toFixed();
  const ROIPercentage = (
    (totalIncomeGenerated / 20 / roofInfo.value.financialAnalysis.tpc) *
    100
  ).toFixed(1);
  const roiYears = roofInfo?.value?.financialAnalysis?.roiYears || 20;
  const currency = roofInfo?.value?.financialAnalysis?.currency || "PKR"

  return (
    <div className="render-function">
      <table className="render-table">
        <thead>
          <tr>
            <td>Years</td>
            <td>Anticipated Electricity cost {currency}/kWh</td>
            <td>kWh generated</td>
            <td>{currency}/year saved off utility bill</td>
            <td>{currency}/year from export</td>
            <td>{currency} year total income generated</td>
            <td>{currency} of system capital cost remaining</td>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.years}</td>
                <td>{item.AnticippatedCost}</td>
                <td>{Number(item.KwhGenerated).toLocaleString("en-US")}</td>
                <td>{Number(item.SavedBill).toLocaleString("en-US")}</td>
                <td>{Number(item.exportGenerated).toLocaleString("en-US")}</td>
                <td>{Number(item.IncomeGenerated).toLocaleString("en-US")}</td>
                <td>{Number(item.CapitalCost).toLocaleString("en-US")}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <table className="render-table renderTable" style={{ marginTop: "20px" }}>
        <thead>
          <tr>
            <td>ROI</td>
            <td>Total ({currency}) saved off utility bill</td>
            <td>Total ({currency}) generated from Export</td>
            <td>Total ({currency}) income generated over {roiYears} years</td>
            <td style={{ width: "155px !important" }}>
              Total Payback after<br></br> {roiYears} Year
            </td>
          </tr>
        </thead>
        <tbody>
          <tr style={{ backgroundColor: "white" }}>
            <td>{ROIPercentage}%</td>
            <td>{Number(totalSavedBill).toLocaleString("en-US")}</td>
            <td>{Number(totalExportGenrated).toLocaleString("en-US")}</td>
            <td>{Number(totalIncomeGenerated).toLocaleString("en-US")}</td>
            <td>
              {Number(
                tableData[tableData.length - 1].CapitalCost
              ).toLocaleString("en-US")}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

const FinancialAnalysis = (props) => {
  const { tableContent } = props;

  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];

  let month = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];

  let et = roofInfo?.value?.financialAnalysis?.et
    ? Number(roofInfo.value.financialAnalysis.et)
    : 0;
  let maintenceCost = roofInfo?.value?.financialAnalysis?.maintenceCost
    ? Number(roofInfo.value.financialAnalysis.maintenceCost)
    : 0;
  let TPC = roofInfo?.value?.financialAnalysis?.tpc
    ? Number(roofInfo.value.financialAnalysis.tpc) + maintenceCost
    : 0 + maintenceCost;
  const aeci = roofInfo?.value?.financialAnalysis?.aeci
    ? parseFloat(roofInfo.value.financialAnalysis.aeci)
    : 0;
  let expTariff = roofInfo?.value?.financialAnalysis?.exportTriff
    ? parseFloat(roofInfo.value.financialAnalysis.exportTriff)
    : 0;
  const aetIncrease = roofInfo?.value?.financialAnalysis?.aetIncrease
    ? parseFloat(roofInfo.value.financialAnalysis.aetIncrease)
    : 0;
  const roiYears = roofInfo?.value?.financialAnalysis?.roiYears || 20;

  let kWhGen = [];
  if (check) {
    for (let j = 0; j < 12; j++) {
      let val = 0;
      for (let i = 0; i < roofData.length; i++) {
        const element = roofData[i].actualGeneration;
        val += element[j];
      }
      kWhGen.push(val);
    }
  } else {
    for (let j = 0; j < 12; j++) {
      const element = roofDetail.actualGeneration;
      const val = element[j];
      kWhGen.push(val);
    }
  }

  let financialAnalysis = [];
  let remainingTPC = TPC;
  for (let i = 1; i <= roiYears; i++) {
    let consumeUnit = [];
    let exportUnit = [];
    let newKWhGen = [];
    for (let j = 0; j < 12; j++) {
      let monthGen = kWhGen[j];
      if (i > 1) {
        monthGen = kWhGen[j] - kWhGen[j] * 0.0055;
      }
      newKWhGen.push(monthGen);
      const monthUnit = roofInfo.value.financialAnalysis[month[j]];
      if (monthGen > monthUnit) {
        consumeUnit.push(monthUnit);
        exportUnit.push(monthGen - monthUnit);
      } else {
        consumeUnit.push(monthGen);
        exportUnit.push(0);
      }
    }

    if (i > 1) {
      et = Number((et + et * (aeci / 100)).toFixed(2));
      expTariff = Number(
        (expTariff + expTariff * (aetIncrease / 100)).toFixed(2)
      );
    }
    const yearConUnit = Object.values(consumeUnit).reduce(
      (sum, val) => sum + val,
      0
    );
    const yearExpUnit = Object.values(exportUnit).reduce(
      (sum, val) => sum + val,
      0
    );
    const expSave = Number((yearExpUnit * expTariff).toFixed());
    const conSave = Number((yearConUnit * et).toFixed());
    const yearSave = expSave + conSave;
    if (i === 1) {
      remainingTPC = yearSave - TPC;
    } else {
      remainingTPC = remainingTPC + yearSave;
    }

    financialAnalysis.push({
      years: i,
      AnticippatedCost: et,
      KwhGenerated: yearConUnit + yearExpUnit,
      SavedBill: conSave,
      exportGenerated: expSave,
      IncomeGenerated: yearSave,
      CapitalCost: remainingTPC,
    });
    kWhGen = newKWhGen;
  }

  const pageDetail = tableContent.find(
    (item) => item.title === "Financial Analysis"
  );

  return (
    <div id="financial-analysis" className="financial-analysis">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="fa-body">
        <p>Financial Analysis</p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(financialAnalysis, roofInfo)}
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default FinancialAnalysis;
